import { useMemo } from "react";

import { useSelector } from "react-redux";
import { compose } from "redux";

import LeadGenRevealActionButtonContainer from "app/pages/sales-intelligence/sub-modules/contacts-search/components/ContactsTableActionsPanel/RevealActionButton/LeadGenRevealActionButtonContainer";
import {
    selectIsPanelExportActive,
    selectMultipleRevealIsInProgress,
} from "app/pages/sales-intelligence/sub-modules/contacts-search/store/selectors";
import { withIntegrationsSyncCall } from "app/pages/sales-intelligence/sub-modules/management/hocs/integration-sync/withIntegrationsSyncCall";
import withDynamicsStatusCall from "app/pages/sales-intelligence/sub-modules/management/hocs/manage-status/withDynamicsStatusCall";
import withHubspotStatusCall from "app/pages/sales-intelligence/sub-modules/management/hocs/manage-status/withHubspotStatusCall";
import withSalesforceStatusCall from "app/pages/sales-intelligence/sub-modules/management/hocs/manage-status/withSalesforceStatusCall";
import withMappingFieldsCall from "app/pages/sales-intelligence/sub-modules/management/hocs/withMappingFieldsCall";

import ActivatedExportPanelContainer from "../ActivatedExportPanel/ActivatedExportPanelContainer";
import ActiveContactsRevealPanelContainer from "../ActiveContactsRevealPanel/ActiveContactsRevealPanelContainer";
import ExportVariantsDropdownContainer from "../ExportVariantsDropdownContainer/ExportVariantsDropdownContainer";

import { StyledActionsPanel } from "./styles";

type TableActionsPanelProps = {
    onApprove?: () => Promise<unknown> | undefined;
};

const TableActionsPanelContainer = ({ onApprove }: TableActionsPanelProps) => {
    const isExportFlowActive = useSelector(selectIsPanelExportActive);
    const isMultipleRevealInProgress = useSelector(selectMultipleRevealIsInProgress);

    const defaultActiveChild = useMemo(() => {
        if (isExportFlowActive) {
            return ActivatedExportPanelContainer;
        }
        if (isMultipleRevealInProgress) {
            return ActiveContactsRevealPanelContainer;
        }
        return undefined;
    }, [isExportFlowActive, isMultipleRevealInProgress]);


    return (
        <StyledActionsPanel defaultActiveChild={defaultActiveChild}>
            {({ activate }) => {
                function activateRevealPanel() {
                    activate(() => ActiveContactsRevealPanelContainer);
                }

                return (
                    <>
                        <LeadGenRevealActionButtonContainer
                            onClick={activateRevealPanel}
                            onApprove={onApprove}
                        />
                        <ExportVariantsDropdownContainer
                            isDisabled={false}
                            onActivate={activate}
                        />
                    </>
                );
            }}
        </StyledActionsPanel>
    );
};

export default compose(
    withSalesforceStatusCall,
    withHubspotStatusCall,
    withDynamicsStatusCall,
    withMappingFieldsCall,
    withIntegrationsSyncCall,
)(TableActionsPanelContainer);
